module.exports = __webpack_public_path__ + "img/google-qibla-finder-03.27dc5279.jpg";